import React from "react";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import Home from "../screens/Home";
import GhostWriting from "../screens/GhostWriting";
import FaithWriter from "../screens/FaithWiter";
import BookEditing from "../screens/BookEditing";
import BookPublishing from "../screens/BookPublishing";
import BookMarketing from "../screens/BookMarketing";
import BookCoverDesign from "../screens/BookCoverDesign";
import AudioBookDesign from "../screens/AudioBookDesign";
import AboutUs from "../screens/AboutUs";
import ContactUs from "../screens/ContactUs";
import FeaturedAuthor from "../screens/FeaturedAuthor";
import PressRelease from "../screens/PressRelease";
import BookTrailer from "../screens/BookTrailer";
import ChildrensBookAndIllustrations from "../screens/ChildrensBookAndIllustrations";
import ChildrenIllustration from "../screens/ChildrenIllustration";
import ChildrenBookPrinting from "../screens/ChildrenBookPrinting";
import AuthorWebsite from "../screens/AuthorWebsite";

import BookFormatting from "../screens/BookFormatting";
import ProofReading from "../screens/ProofReading";
import SocialMediaMarketing from "../screens/SocialMediaMarketing";
import EBookSEO from "../screens/EBookSEO";
import AmazonPrinting from "../screens/AmazonPrinting";
import BookReview from "../screens/BookReview";
import PrPublication from "../screens/PrPublication";
import EbookWriting from "../screens/EbookWriting";

import BookWritingService from "../screens/BookWritingService";

import NovelWriting from "../screens/NovelWriting";


import ArticleWritingPublication from "../screens/ArticleWritingPublication";
import BookVideoTrailer from "../screens/BookVideoTrailer";
import CopyrightsProtection from "../screens/CopyrightsProtection";
import ThankYou from "../screens/ThankYou";

import TermsAndConditions from "../screens/TermsAndConditions";

// New Added

import ComicBookTranslation from "../screens/ComicBookTranslation";
import ArabicBookTranslation from "../screens/ArabicBookTranslation";
import FrenchBookTranslation from "../screens/FrenchBookTranslation";
import SpanishBookTranslation from "../screens/SpanishBookTranslation";
import SpeechWriting from "../screens/SpeechWriting";
import MemoirWriting from "../screens/MemoirWriting";
import NonFictionWriting from "../screens/NonFictionWriting";
import AutoBiographyWriting from "../screens/AutoBiographyWriting";
import ActionAdventureWriting from "../screens/ActionAdventureWriting";
import HipHopWriting from "../screens/HipHopWriting";
import HorrorWriting from "../screens/HorrorWriting";
import ChildrensBookEditors from "../screens/ChildrensBookEditors";
import DevelopmentalEditing from "../screens/DevelopmentalEditing";
import SensitiveReading from "../screens/SensitiveReading";
import BookIllustrationServices from "../screens/BookIllustrationServices";
import ComicBookIllustration from "../screens/ComicBookIllustration";
import ChildrenBookWriting from "../screens/ChildrenBookWriting";
import ComicWriting from "../screens/ComicWriting";
import FictionWriting from "../screens/FictionWriting";
import SeoContentWriting from "../screens/SeoContentWriting";
import MilitaryFictionWriting from "../screens/MilitaryFictionWriting";
import StoryWriting from "../screens/StoryWriting";
import SongWriting from "../screens/SongWriting";
import NarrativeWriting from "../screens/NarrativeWriting";
import RhymeWriting from "../screens/RhymeWriting";
import ScriptWriting from "../screens/ScriptWriting";
import ComedyWriting from "../screens/ComedyWriting";
import MovieWriting from "../screens/MovieWriting";
import ScreenWriting from "../screens/ScreenWriting";
import WikiWriting from "../screens/WikiWriting";
import PrivacyPolicy from "../screens/PrivacyPolicy";




const Router = () => {
  return (
    <BrowserRouter basename="/">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/ghost-writing" element={<GhostWriting />} />
        <Route path="/faith-writer" element={<FaithWriter />} />
        <Route path="/book-editing" element={<BookEditing />} />
        <Route path="/book-publishing" element={<BookPublishing />} />
        <Route path="/book-marketing" element={<BookMarketing />} />
        <Route path="/book-cover-design" element={<BookCoverDesign />} />
        <Route path="/audio-book-design" element={<AudioBookDesign />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/thankyou" element={<ThankYou/>} />
        <Route path="/featured-author" element={<FeaturedAuthor />} />
        <Route path="/press-release" element={<PressRelease />} />
        <Route path="/book-trailer" element={<BookTrailer />} />
        <Route path="/childrens-book-and-illustrations" element={<ChildrensBookAndIllustrations />} />
        <Route path="/ebook-writing" element={<EbookWriting />} />
        <Route path="/novel-writing" element={<NovelWriting />} />
        <Route path="/article-writing-publication" element={<ArticleWritingPublication />} />
        <Route path="/book-video-trailer" element={<BookVideoTrailer />} />
        <Route path="/copyrights-protection" element={<CopyrightsProtection />} />
        <Route
          path="/children-illustration"
          element={<ChildrenIllustration />}
        />
        <Route
          path="/children-book-printing"
          element={<ChildrenBookPrinting />}
        />
        <Route path="/author-website" element={<AuthorWebsite />} />

        {/* New Pages */}
        <Route path="/book-formatting" element={<BookFormatting />} />
        <Route path="/book-writing-service" element={<BookWritingService />} />
        <Route path="/proof-reading" element={<ProofReading />} />
        <Route path="/social-media-marketing" element={<SocialMediaMarketing />} />
        <Route path="/eBook-seo" element={<EBookSEO />} />
        <Route path="/amazon-printing" element={<AmazonPrinting />} />
        <Route path="/book-review" element={<BookReview />} />
        <Route path="/pr-publication" element={<PrPublication />} />

        <Route path="/termsandconditions" element={<TermsAndConditions />} />

        {/* New Added */}

        <Route path="/comic-book-translation" element={<ComicBookTranslation />} />
        <Route path="/arabic-book-translation" element={<ArabicBookTranslation />} />
        <Route path="/french-book-translation" element={<FrenchBookTranslation />} />
        <Route path="/spanish-book-translation" element={<SpanishBookTranslation />} />
        <Route path="/speech-writing" element={<SpeechWriting />} />
        <Route path="/memoir-writing" element={<MemoirWriting />} />
        <Route path="/non-fiction-writing" element={<NonFictionWriting />} />
        <Route path="/autobiography-writing" element={<AutoBiographyWriting />} />
        <Route path="/action-adventure-writing" element={<ActionAdventureWriting />} />
        <Route path="/hip-hop-writing" element={<HipHopWriting />} />
        <Route path="/horror-writing" element={<HorrorWriting />} />
        <Route path="/childrens-book-editors" element={<ChildrensBookEditors />} />
        <Route path="/developmental-editing" element={<DevelopmentalEditing />} />
        <Route path="/sensitive-reading" element={<SensitiveReading />} />
        <Route path="/book-illustration-services" element={<BookIllustrationServices />} />
        <Route path="/comic-book-illustration" element={<ComicBookIllustration />} />
        <Route path="/children-book-writing" element={<ChildrenBookWriting />} />
        <Route path="/comic-writing" element={<ComicWriting />} />
        <Route path="/fiction-writing" element={<FictionWriting />} />
        <Route path="/seo-content-writing" element={<SeoContentWriting />} />
        <Route path="/military-fiction-writing" element={<MilitaryFictionWriting />} />
        <Route path="/story-writing" element={<StoryWriting />} />
        <Route path="/song-writing" element={<SongWriting />} />
        <Route path="/narrative-writing" element={<NarrativeWriting />} />
        <Route path="/rhyme-writing" element={<RhymeWriting />} />
        <Route path="/script-writing" element={<ScriptWriting />} />
        <Route path="/comedy-writing" element={<ComedyWriting />} />
        <Route path="/movie-writing" element={<MovieWriting />} />
        <Route path="/screen-writing" element={<ScreenWriting />} />
        <Route path="/wiki-writing" element={<WikiWriting />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />

      </Routes>
    </BrowserRouter>
  );
};

export default Router;
